import { LocalizedElement } from '../i18n/Language';
import React, { useEffect } from 'react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const RobotsRedirect = () => {
  useEffect(() => {
    // Redirect to backend robots.txt
    window.location.href = `${BACKEND_URL}/api/robots.txt`;
  }, []); // BACKEND_URL is constant, not needed in deps

  return (
    <LocalizedElement as="div" style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      fontFamily: 'system-ui'
    }}>
      <LocalizedElement as="div" style={{ textAlign: 'center' }}>
        <LocalizedElement as="h2">Redirecting to robots.txt...</LocalizedElement>
        <LocalizedElement as="p">If not redirected, <LocalizedElement as="a" href={`${BACKEND_URL}/api/robots.txt`}>click here</LocalizedElement></LocalizedElement>
      </LocalizedElement>
    </LocalizedElement>);

};

export default RobotsRedirect;
